import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "../components/Navbars/AdminNavbar.jsx";
import AdminFooter from "../components/Footers/Footer.jsx";
import Sidebar from "../components/Sidebar/Sidebar.jsx";
import { api_GET } from "../services/api_service.js";
import { getSessionCookie, getTokenCookie } from "../services/session.js";
import routes from "../routes.jsx";
import { Chat } from "constants/chat";

class Admin extends React.Component {

  componentDidMount () {
    Chat();
  }

  componentDidUpdate(e) {    
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.mainContent.scrollTop = 0;    
    this.validaPermissaoAcesso();      
  }

  validaPermissaoAcesso = () => {
    let session = getSessionCookie();  
    var token = getTokenCookie();

    if (session === null || token === null) {
      this.props.history.push("/auth/login");
      return false;      
    }
    
    if (token.expired){
      this.props.history.push("/auth/login");  
      return false;      
    }

    if (this.props.history.location.pathname == "/admin/dashboard" || this.props.history.location.pathname == "/admin/trocarsenha" )
      return;
    
    if (session.perfil == "Master")
      return;

    if (session.perfil != "Gestor")
    {
      this.props.history.push('/auth/login');
      return;
    }

    let permissao = this.props.history.location.pathname.split("/")[2];
    if(permissao == "relatorio")
      permissao = "relatorios"

    api_GET(`usuario/GetPermissaoAcesso/${session.usuarioId}/${permissao}`).then(result => {            
      if (result.status !== 200) {
        this.props.history.push("/admin/dashboard");
      }
      else if (result.data == null){
        this.props.history.push("/admin/dashboard");
      }
    });
  }

  getRoutes = routes => {
    this.validaPermissaoAcesso();

    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  
  getBrandText = path => {
    for (let i = 0; i < routes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          routes[i].layout + routes[i].path
        ) !== -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };  

  render() {
    return (
      <>
        <Sidebar
          {...this.props}
          routes={routes}
          logo={{
            innerLink: "/admin/dashboard",
            imgSrc: require("assets/img/brand/logo.png"),
            imgAlt: "..."
          }}
        />        
        <div className="main-content" ref="mainContent">
          <AdminNavbar
            {...this.props}
            brandText={this.getBrandText(this.props.location.pathname)}
          />
          <Switch>
            {this.getRoutes(routes)}
            <Redirect from="*" to="/admin/dashboard" />
          </Switch>
          <Container fluid>
            <AdminFooter />
          </Container>
        </div>
      </>
    );
  }
}

export default Admin;
